/**
 * DeepSeek Configuration
 *
 * DeepSeek exposes an OpenAI-compatible API. Models are prefixed with
 * "deepseek/" to route through DeepSeekProvider (mirrors grok.ts's pattern).
 */

export const DEEPSEEK_MODELS = {
  // Legacy "Fastest" tier model — superseded by GPT-5.6 Luna (see
  // gui/src/config/openai.ts) but kept selectable for parity / legacy pins.
  DEEPSEEK_V4_FLASH: 'deepseek/deepseek-v4-flash',
  DEEPSEEK_V4_PRO: 'deepseek/deepseek-v4-pro',
};

export const DEFAULT_DEEPSEEK_MODEL = DEEPSEEK_MODELS.DEEPSEEK_V4_FLASH;

export const AVAILABLE_DEEPSEEK_MODELS = [
  {
    id: DEEPSEEK_MODELS.DEEPSEEK_V4_FLASH,
    name: 'DeepSeek V4 Flash',
    provider: 'deepseek',
    family: 'deepseek',
    description: 'Fast, efficient — previous Fastest tier default',
    capabilities: ['text', 'reasoning'],
    tier: 'fast',
  },
  {
    id: DEEPSEEK_MODELS.DEEPSEEK_V4_PRO,
    name: 'DeepSeek V4 Pro',
    provider: 'deepseek',
    family: 'deepseek',
    description: 'Frontier coding and long-horizon agent quality',
    capabilities: ['text', 'reasoning'],
    tier: 'premium',
  },
];

/**
 * Check if a model ID is a DeepSeek model
 */
export function isDeepSeekModel(modelId: string): boolean {
  return modelId.startsWith('deepseek/');
}

/**
 * Get DeepSeek model name without prefix
 */
export function getDeepSeekModelName(modelId: string): string {
  return modelId.replace('deepseek/', '');
}
